module.exports = __webpack_public_path__ + "static/media/bell-plus.fa4742d9.svg";